import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    RadioGroup,
    FormControlLabel,
    Radio
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSubCompaniesData } from "../../../store/selectors/subCompaniesSelector";
import { GeneralButton } from "../../../common/ui/GeneralButton";

interface SelectSubCompanyDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (selectedSubCompanyId: number | null) => void;
    initialSubCompanyId: number | null | undefined;
}

const SelectSubCompanyDialog: React.FC<SelectSubCompanyDialogProps> = ({
    open,
    onClose,
    onSave,
    initialSubCompanyId,
}) => {
    const { t } = useTranslation();
    const subCompanies = useSubCompaniesData();
    const [selectedSubCompanyId, setSelectedSubCompanyId] = useState<number | null>(null);

    useEffect(() => {
        setSelectedSubCompanyId(initialSubCompanyId ?? null);
    }, [initialSubCompanyId, open]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t("employeesPage.subCompanyAssigment.selectSubCompany")}</DialogTitle>
            <DialogContent>
                <RadioGroup
                    value={selectedSubCompanyId !== null ? String(selectedSubCompanyId) : "-"}
                    onChange={(e) =>
                        setSelectedSubCompanyId(e.target.value === "-" ? null : Number(e.target.value))
                    }
                >
                    <FormControlLabel
                        value="-"
                        control={<Radio />}
                        label={t("employeesPage.subCompanyAssigment.noSubCompany")} />
                    {subCompanies.map((sub) => (
                        <FormControlLabel
                            key={sub.id}
                            value={String(sub.id)}
                            control={<Radio />}
                            label={sub.name}
                        />
                    ))}
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <GeneralButton
                    appVariant="secondary"
                    onClick={onClose}
                >
                    {t("buttons.cancel")}
                </GeneralButton>
                <GeneralButton
                    onClick={() => onSave(selectedSubCompanyId)}
                >
                    {t("buttons.ok")}
                </GeneralButton>
            </DialogActions>
        </Dialog>
    );
};

export default SelectSubCompanyDialog;
